// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3vljy","modalForm":"UpgradeEpcsModal_modalForm__2I3_7","modalFooter":"UpgradeEpcsModal_modalFooter__3EEZV"};